import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Justification } from '../models/justification';
import { updateJustificationEndpoint } from './const';

export const updateJustification = (justification: Justification) => {
    return getHttpClient().post({ url: updateJustificationEndpoint, data: JSON.stringify(justification) });
};
